export default __webpack_public_path__ + "assets/front/scss/common.f5a4419abe322293eab3329e7a237a9b.css";